import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api';

export const AuthContext = createContext();
export const VenueContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // on mount, verify session via HttpOnly cookie
  useEffect(() => {
    api.get('/check_user_session/', { withCredentials: true })
      .then(() => setIsAuthenticated(true))
      .catch(() => setIsAuthenticated(false))
      .finally(() => setLoading(false));
  }, []);

  // call after sign-in to refresh auth flag
  const login = () => setIsAuthenticated(true);

  const logout = async () => {
    try {
      await api.post('/logout/', {}, { withCredentials: true });
    } catch (err) {
      console.error('Logout request failed', err);
    } finally {
      localStorage.removeItem('bd2mSessionToken');
      setIsAuthenticated(false);
    }
  };

  if (loading) return <div>Loading…</div>;

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
